/**
 * Shoulder pad picker — TWO side-by-side StyleSelects, one for Left and one for
 * Right shoulder. Lets the tailor specify asymmetric padding (e.g., FDJ-A22025B
 * on the right and FDJ-A20595B on the left for sloping-shoulder customers).
 *
 * Both sides share the same FDJ-* code catalog (color + thickness in cm + inch).
 * A small "Match L→R" button copies left to right in one click.
 *
 * Props (mirrors StyleSelect's contract via `StyleSelectComponent`):
 *   styling, setStyling — current section state and setter
 *   StyleSelectComponent — the section-local StyleSelect implementation
 *     (each parent page defines its own due to local state)
 *   testId — base data-testid prefix
 */
import { Button } from "@/components/ui/button";
import { Link2 } from "lucide-react";

export default function ShoulderPadPair({
  styling,
  setStyling,
  StyleSelectComponent,
  testId = "shoulder-pad",
}) {
  const left = styling?.shoulder_pad_left || "";
  const matchRight = () => {
    if (!left) return;
    setStyling({ ...styling, shoulder_pad_right: left });
  };

  return (
    <>
      <div data-testid={`${testId}-left-wrap`}>
        <StyleSelectComponent
          label="Shoulder Pad (L)"
          value={styling?.shoulder_pad_left}
          onChange={(v) => setStyling({ ...styling, shoulder_pad_left: v })}
          options={[]}
          codePrefix="shoulder_pad_left"
        />
      </div>
      <div data-testid={`${testId}-right-wrap`} className="relative">
        <StyleSelectComponent
          label="Shoulder Pad (R)"
          value={styling?.shoulder_pad_right}
          onChange={(v) => setStyling({ ...styling, shoulder_pad_right: v })}
          options={[]}
          codePrefix="shoulder_pad_right"
        />
        <Button
          type="button"
          size="sm"
          onClick={matchRight}
          disabled={!left}
          title="Copy Left → Right"
          className="absolute -top-1 right-0 h-5 px-1.5 text-[9px] bg-purple-600 hover:bg-purple-700 text-white disabled:opacity-30"
          data-testid={`${testId}-match-btn`}
        >
          <Link2 size={9} className="mr-0.5" /> Match L→R
        </Button>
      </div>
    </>
  );
}
